import React from 'react';
import classnames from 'classnames';
import { uniq } from 'lodash';

import { expandDataProps } from 'utils/helper/common';

import './input-toggles.scss';

import type { Data } from 'types';

type Items = Array<{
  label: string,
  value: string
}>;

type Props = {
  items: Items,
  value: Array<string>,
  limit?: number,
  data?: Data,
  onChange: (values: Array<string>, data: Data) => void
};

class InputToggles extends React.Component<Props> {
  handleClick = (event: React.SyntheticEvent<HTMLDivElement>): void => {
    const { onChange, value } = this.props;
    const target = event.currentTarget;
    const data = target.dataset ?? {};
    const itemValue = data.arg;

    if (itemValue === undefined) {
      return;
    }

    const selectedItems = value.includes(itemValue) ?
      value.filter(v => v !== itemValue) :
      uniq([...value, itemValue]);

    onChange(selectedItems, data);
  };

  render() {
    const { items, limit, value, data } = this.props;
    const isLimitReached = limit ? value.length >= limit : false;

    return (
      <div className="input-toggles">
        {
          items.map(item => {
            const isSelected = value.includes(item.value);
            const isDisabled = isLimitReached && !isSelected;
            const itemClasses = classnames({
              'input-toggles__item': true,
              'input-toggles__item--active': isSelected,
              'input-toggles__item--disabled': isDisabled
            });

            return (
              <div
                key={`input-toggles-item-${item.value}`}
                className={itemClasses}
                data-arg={item.value}
                onClick={!isDisabled ? this.handleClick : undefined}
                {...expandDataProps(data)}
              >
                <span>{item.label}</span>
              </div>
            );
          })
        }
      </div>
    );
  }
}

export default InputToggles;
